export const environment = {
  production: true,
  authConfig: {
    baseUrl: 'https://www.freelancer.com/auth',
    authHashCookie: 'GETAFREE_AUTH_HASH_V2',
    userIdCookie: 'GETAFREE_USER_ID',
  },
  uiConfig: {
    assetsBaseUrl: 'https://www.f-cdn.com/assets/webapp/assets',
    locale: 'en',
  },
  datastoreConfig: {
    apiBaseUrl: 'https://www.freelancer.com/api',
    ajaxBaseUrl: 'https://www.freelancer.com/ajax-api',
    webSocketUrl: 'https://notifications.freelancer.com',
    enableStoreFreeze: false,
  },
  trackingConfig: {
    trackingEndpoint: 'https://t.freelancer.com/0px.gif',
    sessionCookie: '_tracking_session',
    navigationPerformanceSamplingRate: 1,
    enableErrorTracking: true,
    sentryDsn: 'https://89961363a0f642558f5fedad5195eb89@sentry.io/85230',
    gitRevision: '62bc81a',
    buildDate: 'Wed Oct 25 2017 11:14:56 GMT-0400 (EDT)',
  },
  billingConfig: {
    baseUrl: 'https://api.flnbln.net',
  },
  facebookAppId: '',
  languageCookie: 'GETAFREE_LANGUAGE',
};



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/environments/environment.ts